/**
 * Routes that are allowed when the subscription is suspended.
 * These routes enable owners to access billing pages to restart their subscription.
 */
export const SUSPENDED_BILLING_ROUTES = [
    'suspended',
    'settings.billing.overview',
    'settings.billing.overview.upgrade',
    '/settings/upgrade',
];
